import { render, staticRenderFns } from "./cert_pendding.vue?vue&type=template&id=cb523300&"
import script from "./cert_pendding.vue?vue&type=script&lang=js&"
export * from "./cert_pendding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports